import axiosInstance from "client/lib/axiosInterceptor";
import { loadScript } from "client/lib/utils/loadScript";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { actions } from "store/features/freshworks/slice";
import { useAppDispatch, useAppSelector } from "store/store";

export const useFreshworksWidget = () => {
    const router = useRouter();
    const state = useAppSelector((store) => store.freshworks.state);
    const hidden = useAppSelector((store) => store.freshworks.hidden);
    const dispatch = useAppDispatch();
    const isLoading = state === "loading";

    async function openFreshworksWidget() {
        await waitForFreshworksWidget();
        await preFillFreshworksWidget();

        window.FreshworksWidget?.("hide", "launcher");
        window.FreshworksWidget?.("open");
        disableFooterPointers();
    }

    const loadFreshworksScript = async () => {
        dispatch(actions.changeState("loading"));

        return new Promise<boolean>((resolve) => {
            loadScript("https://widget.freshworks.com/widgets/151000005167.js", () => {
                setTimeout(() => {
                    if (isFreshworksWidgetLoaded()) {
                        dispatch(actions.changeState("loaded"));
                    } else {
                        dispatch(actions.changeState("uninitialized"));
                    }
                }, 500);
                resolve(isFreshworksWidgetLoaded());
            });
            const script = document.createElement("script");
            script.innerHTML = `
               window.fwSettings={
                   'widget_id':151000005167
               };
               !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()
        `;
            document.head.appendChild(script);
        });
    };

    function delay(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async function disableFooterPointers(): Promise<void> {
        let counter = 0;
        while (counter <= 20) {
            await delay(500);
            const iframe = document.querySelector("#widget-frame") as HTMLIFrameElement | null | undefined;
            const footerElement = iframe?.contentDocument?.querySelector('[class*="elements__WidgetFooter"]');
            if (footerElement) {
                footerElement.setAttribute("style", "pointer-events: none;");
                break;
            }
            counter++;
        }
    }

    async function waitForFreshworksWidget() {
        while (!isFreshworksWidgetLoaded()) {
            if (state === "uninitialized") {
                await loadFreshworksScript();
            }
            await new Promise((resolve) => setTimeout(resolve, 100));
        }
    }

    function isFreshworksWidgetLoaded() {
        return !!window.FreshworksWidget;
    }
    async function preFillFreshworksWidget() {
        const prefill = await generateContactFormData();

        window.FreshworksWidget?.("prefill", "ticketForm", prefill);
        window.FreshworksWidget?.("hide", "ticketForm", [
            "custom_fields.cf_user_ip",
            "custom_fields.cf_page",
            "custom_fields.cf_user_id",
            "custom_fields.cf_site",
        ]);
    }

    async function generateContactFormData() {
        const customFields = {
            cf_user_ip: await fetchIp(),
            cf_page: router.asPath,
            cf_site: "imageresizer",
        };
        return {
            custom_fields: customFields,
        };
    }

    const fetchIp = async () => {
        const res = await axiosInstance.get<{ ip: string }>(`${process.env.NEXT_PUBLIC_BE_URL}/get-ip`);
        return res.data.ip;
    };

    function updateFreshworksPageData() {
        if (!isFreshworksWidgetLoaded()) return;
        const route = router.asPath;
        window.FreshworksWidget?.("prefill", "ticketForm", {
            custom_fields: {
                cf_page: route,
            },
        });
    }

    useEffect(updateFreshworksPageData, [router]);

    return { openFreshworksWidget, isLoading, isLoaded: state === "loaded", hidden };
};
